/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ContentDubAndSubP } from './contentDubAndSubP';
import { ContentGroupP } from './contentGroupP';
import { ContentMetadataP } from './contentMetadataP';
import { ContentPosterP } from './contentPosterP';
import { ContentReleaseDateP } from './contentReleaseDateP';
import { LabelP } from './labelP';
import { LicenseP } from './licenseP';
import { Timestamp } from './timestamp';


export interface ContentP { 
    advertisable?: boolean;
    blur?: boolean;
    boxOfficeCategory?: string;
    contentGroups?: Array<ContentGroupP>;
    contentReleaseDates?: Array<ContentReleaseDateP>;
    createdById?: number;
    createdByName?: string;
    creationDate?: Timestamp;
    cut?: boolean;
    dislikeCount?: number;
    dubAndSubs?: Array<ContentDubAndSubP>;
    dueDate?: Timestamp;
    encodedMediaUrl?: string;
    external?: boolean;
    guid?: string;
    id?: number;
    imdbId?: string;
    labels?: Array<LabelP>;
    lastUpdateById?: number;
    lastUpdateByName?: string;
    lastUpdateDate?: Timestamp;
    licenses?: Array<LicenseP>;
    likeCount?: number;
    meUrl?: string;
    metadata?: ContentMetadataP;
    name?: string;
    posters?: Array<ContentPosterP>;
    price?: number;
    proxyMediaUrl?: string;
    publishPoint?: ContentP.PublishPointEnum;
    rawMediaUrl?: string;
    recievedDate?: Timestamp;
    scriptUrl?: string;
    status?: string;
    trailerUrl?: string;
    transcodedMediaUrl?: string;
    turkish?: boolean;
}
export namespace ContentP {
    export type PublishPointEnum = 'Production' | 'Test';
    export const PublishPointEnum = {
        Production: 'Production' as PublishPointEnum,
        Test: 'Test' as PublishPointEnum
    };
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/cms-vod-client-api/model/contentP.ts